import { api } from "config/axios-context";
import { CommissionTypes } from "types/graphql"
import { DateUtil } from "utilities/date-utilities";

type BookingChannel = {
    type: CommissionTypes,
    commission: number
}

function calculateChannelCommission(total: number, channel: BookingChannel) {
    if (!total) return 0;
    switch (channel.type) {
        case CommissionTypes.Total:
            return total;
        case CommissionTypes.Percent:
            return (total * (channel.commission / 100)).toFixed(2);
        default:
            return 0;
    }
}

function calculateTotalPrice(inDate: Date, outDate: Date, data: {date: Date, price: number}[]) {
    let total = 0;
    while (data.length && inDate < outDate) {
        const day = data.find(d => DateUtil.compareOnAsIsoDate(d.date, inDate));
        if (day) {
            total += day.price;
        } else {
            total += data[0].price;
        }
        inDate.setDate(inDate.getDate() + 1);
    }

    return total;
}

async function deleteBooking(id: number) {
    try {
        const response = await api.delete('booking/delete?id=' + id);
        if (!response.success) {
            throw "Could not delete booking";
        }

    } catch (error) {
        console.error("Error deleting booking:", error);
        throw error;
    }
}

export default {
    calculateChannelCommission,
    calculateTotalPrice,
    deleteBooking
}
